import { useQuery } from "@rocicorp/zero/react";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useRef } from "react";

import { Board } from "@/features/tasks/components/board";
import { Tabs } from "@/features/tasks/components/tabs";
import { useZero } from "@/hooks/use-zero";
import { BoardWithLists, GroupedTasks, Task } from "@/lib/types";

export const Route = createFileRoute("/_app/w/$slug/$boardKey/")({
  beforeLoad: () => ({
    layoutOptions: {
      safeArea: false,
    },
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { boardKey } = Route.useParams();
  const zero = useZero();
  const [board, boardResult] = useQuery(
    zero.query.boards
      .where("boardKey", boardKey)
      .related("lists", (q) => q.orderBy("position", "asc"))
      .one(),
  );
  const [tasks] = useQuery(
    zero.query.tasks
      .where("boardId", board?.id ?? "")
      .orderBy("position", "asc"),
    { enabled: !!board },
  );
  const groupedTasks = groupTasks(board, tasks);
  const viewportRef = useRef<HTMLDivElement>(null);

  if (!board) {
    return boardResult.type === "complete" ? (
      <Navigate to=".." replace />
    ) : null;
  }

  return (
    <>
      <Tabs viewportRef={viewportRef} lists={board.lists} />
      <Board
        className="-mx-3"
        board={board}
        tasks={groupedTasks}
        viewportRef={viewportRef}
      />
    </>
  );
}

function groupTasks(board: BoardWithLists | undefined, tasks: Task[]) {
  const grouped: GroupedTasks = {};
  if (!board) {
    return grouped;
  }
  for (const list of board.lists) {
    grouped[list.id] = [];
  }
  for (const task of tasks) {
    grouped[task.listId]?.push(task);
  }
  return grouped;
}
